const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
const orderDate = {
  deliveryOrderSurvey: {
    type: 'post',
    url: `${apiName}/order/delivery/orderSurvey`
  },
  //入库信息
  stockSearch: {
    type: 'post',
    url: `/ec-pc-api/pack/stock/search`
  },
  //入库信息导出
  stockExport: {
    type: 'post',
    url: `/ec-pc-api/pack/stock/export`
  },
  //缺货包件汇总分页查询
  packList: {
    type: 'post',
    url: `/ec-pc-api/shortage/pack/list`
  },
  //缺货包件详情
  packDetails: {
    type: 'post',
    url: `/ec-pc-api/shortage/pack/details`
  },
  //缺货包件详情
  detailExport: {
    type: 'post',
    url: `/ec-pc-api/shortage/pack/detail/export`
  },
  //缺货包件 -出货信息编辑
  shippingInfoUpdate: {
    type: 'post',
    url: `/ec-pc-api/order/delivery/shippingInfo/update`
  },
  deliveryShortageScatteredInfo: {
    type: 'post',
    url: `${apiName}/order/delivery/shortageScatteredInfo`
  },
  deliveryOrderList: {
    type: 'post',
    url: `${apiName}/order/delivery/orderList`
  },
  deliveryNonStockOutOrderList: {
    type: 'post',
    url: `${apiName}/order/delivery/nonStockOutOrderList`
  },
  deliveryOrderNum: {
    type: 'post',
    url: `${apiName}/order/delivery/orderNum`
  },
  deliveryOrderGoodsDetail: {
    type: 'get',
    url: `${apiName}/order/delivery/orderGoodsDetail`
  },
  // 新增办公平台导出接口
  importExcel: {
    type: 'post',
    url: `/qu-platform-excel-api/excel/export/task`
  },
  //订单包间导出
  shortagePackListPageExport: {
    type: 'post',
    url: `/ec-pc-api/order/delivery/shortagePackListPage/export`
  },
  //订单缺货tab页操作日志
  orderStockOutLog: {
    type: 'post',
    url: `/ec-pc-api/order/delivery/orderStockOutLog`
  },
  //缺货商品弹窗操作日志
  goodsStockOutLog: {
    type: 'post',
    url: `/ec-pc-api/order/delivery/goodsStockOutLog`
  },
  deliveryOutOfStockProducts: {
    type: 'post',
    url: `${apiName}/order/delivery/OutOfStockProducts`
  },
  deliveryShortagePackListPage: {
    type: 'post',
    url: `${apiName}/order/delivery/shortagePackListPage/v2`
  },
  deliveryPackOrderList: {
    type: 'get',
    url: `${apiName}/order/delivery/packOrderList`
  },
  deliveryOutOfStockRecords: {
    type: 'post',
    url: `${apiName}/order/delivery/OutOfStockRecords`
  },
  deliveryOrderNo: {
    type: 'get',
    url: `${apiName}/order/delivery/orderNo`
  },
  deliverySelectReply: {
    type: 'post',
    url: `${apiName}/order/delivery/selectReply`
  },
  deliveryInsertReply: {
    type: 'post',
    url: `${apiName}/order/delivery/insertReply`
  },
  deliveryUpdateReply: {
    type: 'post',
    url: `${apiName}/order/delivery/updateReply`
  },
  deliveryGetOptions: {
    type: 'get',
    url: `${apiName}/order/delivery/getOptions`
  },
  deliveryAveOrderDay: {
    type: 'post',
    url: `${apiName}/order/delivery/aveOrderDay`
  },
  workflowInfoSelectListByPage: {
    type: 'post',
    url: `${apiName}/order/delivery/new/workflowInfo/selectListByPage`
  },
  workflowPackSelectListByPage: {
    type: 'post',
    url: `${apiName}/order/delivery/new/workflowPack/selectListByPage`
  },
  workflowPackExpectShipDaily: {
    type: 'post',
    url: `${apiName}/order/delivery/new/workflowPack/expectShipDaily`
  },
  workflowPackActualOfflineDaily: {
    type: 'post',
    url: `${apiName}/order/delivery/new/workflowPack/actualOfflineDaily`
  }
}

export default orderDate;
